import { render, staticRenderFns } from "./UserTransactionForm.vue?vue&type=template&id=7b2bc2ca&"
import script from "./UserTransactionForm.vue?vue&type=script&lang=js&"
export * from "./UserTransactionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports